import React from "react";

export default function PlaceholderTab({ note }) {
  return <div className="text-center text-slate-400 italic py-10" data-testid="payroll-tab-placeholder">{note}</div>;
}
